import {
  SET_ACTIVE_HT,
  SET_ACTIVE_LT,
} from '../mutationTypes';

const moduleCalculation = {
  namespaced: true,

  state: {
    activeCalculationData: {
      activeHT: 211,
      activeLT: 128,
    },
  },

  getters: {

  },

  actions: {

  },

  mutations: {
    [SET_ACTIVE_HT](state, payload) {
      state.activeCalculationData.activeHT = payload;
    },
    [SET_ACTIVE_LT](state, payload) {
      state.activeCalculationData.activeLT = payload;
    },
  },
};

export default moduleCalculation;
